import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { classNames } from "../../utils/helpers";
import { View } from "../view";
import { Text } from "../text";
import s from './ProgressBar.module.css';
export const ProgressBar = ({ value, max = 100, className, attributes, label, labelAlign = 'left', barColor, valueColor, containerClassName, }) => {
    const rootClassNames = classNames(s.root, className);
    const containerClassNames = classNames(s.container, containerClassName);
    const textClassNames = classNames(s.text, labelAlign && s[`--label-align-${labelAlign}`]);
    const passedStyle = (attributes === null || attributes === void 0 ? void 0 : attributes.style) || {};
    const style = Object.assign(Object.assign(Object.assign({}, passedStyle), (barColor && { '--st-bar-color': `var(--st-color-${barColor})` })), (valueColor && { '--st-value-color': `var(--st-color-${valueColor})` }));
    return (_jsxs(View, { align: "center", padding: 0, direction: labelAlign === 'left' ? 'row' : 'row-reverse', justify: labelAlign === 'left' ? 'start' : 'end', className: containerClassNames, attributes: {
            'data-testid': 'st-progressbar',
            'aria-label': `${label} progress bar ${value} out of ${max}.`,
            tabIndex: 0,
        }, children: [_jsx(Text, { className: textClassNames, attributes: { 'aria-hidden': true }, children: label }), _jsx("progress", Object.assign({ max: max, value: value }, attributes, { "aria-hidden": true, className: rootClassNames, style: style }))] }));
};
